import campDatesIcon from '../assets/icons/plc/info/camp-dates.png'
import locationIcon from '../assets/icons/plc/info/location.png'
import residenceIcon from '../assets/icons/plc/info/residence.png'
import { sharedPlcTeamBuildingIcon } from '../assets/index'
import workshopsIcon from '../assets/icons/plc/features/workshops.png'
import expertSessionsIcon from '../assets/icons/plc/features/expert-sessions.png'
import certificationIcon from '../assets/icons/plc/features/certification.png'
import studentsIcon from '../assets/icons/plc/audience/students.png'
import youngProfessionalsIcon from '../assets/icons/plc/audience/young-professionals.png'
import aspiringLeadersIcon from '../assets/icons/plc/audience/aspiring-leaders.png'
import socialActivistsIcon from '../assets/icons/plc/audience/social-activists.png'
import entrepreneursIcon from '../assets/icons/plc/audience/entrepreneurs.png'
import changeMakersIcon from '../assets/icons/plc/audience/change-makers.png'
import groupPhoto from '../assets/images/plc/group-photo.png'
import speakerDinesh from '../assets/images/plc/speakers/dinesh-patel.png'
import speakerSomanath from '../assets/images/plc/speakers/s-somanath.png'
import speakerYogi from '../assets/images/plc/speakers/yogi-kochhar.png'
import speakerRachit from '../assets/images/plc/speakers/rachit-ranjan.png'
import speakerMahendra from '../assets/images/plc/speakers/mahendra-dohare.png'
import speakerKeshav from '../assets/images/plc/speakers/keshav-gupta.png'
import speakerAmit from '../assets/images/plc/speakers/amit-mulani.png'
import speakerSuresh from '../assets/images/plc/speakers/suresh-prabhu.png'
import speakerGopal from '../assets/images/plc/speakers/gopal-krishna-agarwal.png'
import speakerSatish from '../assets/images/plc/speakers/satish-marathe.png'

export const plcHero = {
  title: 'Public Leadership Camp 4.0',
  subtitle:
    "Transform your leadership potential through our intensive 3-day residential program designed to build confident, responsible, and visionary leaders for tomorrow's India.",
}

export const plcInfoCards = [
  {
    title: 'Camp Dates',
    value: 'January 2-4, 2026',
    iconSrc: campDatesIcon,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Location',
    value: 'The Millennium School, Surat, gujarat',
    iconSrc: locationIcon,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Residence Venue',
    value: 'Paraizo the club',
    iconSrc: residenceIcon,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
  {
    title: 'Participants',
    value: 'Limited to 100 Youth',
    iconSrc: sharedPlcTeamBuildingIcon,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
]

export const plcAboutParagraphs = [
  "Public Leadership Camp (PLC) is Disha Foundation's flagship residential program that has transformed thousands of young lives since its inception. PLC 4.0 represents the evolution of our leadership training methodology, incorporating the latest insights in youth development, leadership psychology, and nation-building principles.",
  'This intensive 3-day program combines theoretical knowledge with practical application through interactive workshops, team-building exercises, motivational sessions with renowned speakers, and real-world problem-solving challenges.',
]

export const plcProgramFeatures = [
  {
    title: 'Interactive Workshops',
    description:
      'Hands-on sessions to develop leadership, communication, and decision-making skills.',
    iconSrc: workshopsIcon,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Expert Sessions',
    description:
      'Inspiring talks from successful leaders, entrepreneurs, and social change makers',
    iconSrc: expertSessionsIcon,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Team Building Activities',
    description: 'Team activities that build collaboration, trust, and leadership skills.',
    iconSrc: sharedPlcTeamBuildingIcon,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Certification & Recognition',
    description:
      'Official certificate of completion and recognition for outstanding participants',
    iconSrc: certificationIcon,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
]

export const plcClosingParagraph =
  "PLC is not just a training program—it's a transformative experience that challenges participants to step out of their comfort zones, discover their leadership potential, and commit to making a positive difference in society."

export const plcGroupPhoto = groupPhoto

export const plcAudience = [
  {
    title: 'Students',
    description: 'Helping students build leadership skills and prepare for future opportunities.',
    iconSrc: studentsIcon,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Young Professionals',
    description:
      'Early-career professionals seeking to enhance their leadership capabilities and network',
    iconSrc: youngProfessionalsIcon,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Aspiring Leaders',
    description: 'Youth passionate about making a difference in their communities and society',
    iconSrc: aspiringLeadersIcon,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Social Activists',
    description: 'Individuals involved in social work and community development initiatives',
    iconSrc: socialActivistsIcon,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
  {
    title: 'Entrepreneurs',
    description: 'Young business owners and startup founders building leadership teams',
    iconSrc: entrepreneursIcon,
    iconBgColor: 'rgba(7,30,183,0.12)',
  },
  {
    title: 'Change Makers',
    description: 'Anyone committed to personal growth and contributing to nation building',
    iconSrc: changeMakersIcon,
    iconBgColor: 'rgba(183,7,171,0.12)',
  },
]

export const plcCta = {
  title: 'Ready to Transform Your Leadership Journey?',
  description:
    'Join PLC 4.0 and become part of a community of young leaders committed to building a better India. Limited seats available—register now to secure your spot!',
  brochureUrl: '/contact',
}

export const plcSpeakers = [
  { name: 'Shri Dinesh Patel', role: 'Founder, Disha Foundation', photo: speakerDinesh, photoTop: -10 },
  { name: 'Dr. S. Somanath', role: 'Former Chairman, ISRO', photo: speakerSomanath, photoTop: -20 },
  { name: 'Prof. Yogi Kochhar', role: 'AI Futurist & Author', photo: speakerYogi, photoTop: -20 },
  { name: 'Shri Rachit Ranjan', role: 'Chief Policy Officer, Zepto', photo: speakerRachit, photoTop: -10 },
  {
    name: 'Shri Mahendra Dohare',
    role: 'Executive Director Central Bank of India',
    photo: speakerMahendra,
    photoTop: -20,
  },
  {
    name: 'Shri Keshav Gupta',
    role: 'Senior Director – Growth, M&A and Business Planning, MAX Healthcare',
    photo: speakerKeshav,
    photoTop: -20,
  },
  {
    name: 'Shri Amit Mulani',
    role: 'MD, Atlantico International Import Export Trainer',
    photo: speakerAmit,
    photoTop: -10,
    photoLeft: -106,
    photoWidth: 480,
  },
  {
    name: 'Shri Suresh Prabhu',
    role: 'Former Union Minister of Civil Aviation',
    photo: speakerSuresh,
    photoTop: -16,
  },
  {
    name: 'Shri Gopal Krishna Agarwal',
    role: 'National Spokesperson for Economic Affairs for BJP and CA',
    photo: speakerGopal,
    photoTop: -20,
  },
  {
    name: 'Shri Satish Marathe',
    role: 'Director, Central Board of the Reserve Bank of India,',
    photo: speakerSatish,
    photoTop: -8,
  },
]
